export default __webpack_public_path__ + "static/media/EAST2580.34I-34715_-19304_0.d4ae4618.jpg";